import { Controller } from "stimulus"
import axios from "axios";
export default class extends Controller {
  changeClient(e){
    const selectedOptions = e.target.selectedOptions
    const clientIds = [...selectedOptions].map((element) => element.value)

    this.handleOwnerForm(clientIds)
  }

  handleOwnerForm(clientIds){
    axios({url: '/nahln_posters/owner_form', method: 'POST', 
      headers: { 
      Accept: "text/vnd.turbo-stream.html"
      },
      data: {
        client_ids: clientIds
      } 
    }).then(html => Turbo.renderStreamMessage(html.data))
  }
}